import { chakra, Heading } from '@chakra-ui/react';

type Props = {
  name: string
};

export default function DividualsChartHeading({name}: Props) {
  return (
    <Heading
      as="h4"
      display="inline-block"
      position="relative"
      maxW="calc(100% - 4rem)"
      fontSize={['lg', 'lg', "1.5rem"]}
      fontFamily="inherit"
      fontWeight="inherit"
      p={['0.5rem 2.6875rem 0.875rem', "0.875rem 4.875rem 1.375rem"]}
      lineHeight="1.5"
      borderRadius="3xl"
      bgColor="blue.500"
      color="white"
      _after={{
        content: '""',
        position: 'absolute',
        bottom: '0',
        left: '50%',
        transform: 'translate(-50%, 100%)',
        w: ['20px', '30px'],
        h: ['12px', '20px'],
        clipPath: 'polygon(0 0, 100% 0, 50% 100%)',
        bgColor: 'inherit'
      }}
    >
      あなたの
      <br />
      <chakra.span fontSize={['1.5rem', '1.5rem', "2.25rem"]}>“{name}”</chakra.span>
      <br />
      のときの分人グラフ
    </Heading>
  );
}
